import { render, staticRenderFns } from "./report-threads.vue?vue&type=template&id=7f2604d4"
import script from "./report-threads.vue?vue&type=script&lang=js"
export * from "./report-threads.vue?vue&type=script&lang=js"
import style0 from "./report-threads.vue?vue&type=style&index=0&id=7f2604d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports